export default __webpack_public_path__ + "static/media/galleries.7de6d396.svg";